<!-- begin:: Header Topbar -->
<ng-container *ngIf="user$ | async as _user">
  <ng-container *ngIf="!(isFilteredView$ | async) && _user && _user.userName !== 'super_admin'">
    <div class="topbar-item" ngbTooltip="Recent Accessed" (click)="openRecentAccessed()">
      <div class="btn btn-icon btn-clean btn-dropdown btn-lg pulse pulse-primary">
        <span class="svg-icon svg-icon-md svg-icon-primary">
          <span
            class="force-primary"
            [inlineSVG]="'./assets/media/svg/icons/General/rewind.svg'"
          ></span>
        </span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="_user && _user.userName && _user.userName !== 'super_admin'">
    <ng-container *ngIf="!(isFilteredView$ | async) && searchDisplay">
      <!--begin: Search -->
      <ng-container>
        <div>
          <ng-template ngxPermissionsOnly="canSearchGeneral">
            <kt-search-dropdown
              [icon]="'./assets/media/svg/icons/General/Search.svg'"
              [useSVG]="true"
            ></kt-search-dropdown>
          </ng-template>
        </div>
      </ng-container>
      <!--end: Search -->
    </ng-container>
    <div
      *ngxPermissionsOnly="'canAccessFilteredView'"
      [ngbTooltip]="(isFilteredView$ | async) ? 'End Session' : 'Focused View'"
      class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary margin-auto"
      (click)="openFilteredViewDialog()"
    >
      <span class="svg-icon svg-icon-xl svg-icon-primary">
        <span
          inlineSVG="./assets/media/svg/icons/General/focus-svgrepo-com.svg"
          *ngIf="!(isFilteredView$ | async)"
        ></span>
        <span
          inlineSVG="./assets/media/svg/icons/General/sign_out.svg"
          *ngIf="isFilteredView$ | async"
        ></span>
      </span>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      !(isFilteredView$ | async) && _user && _user.userName && _user.userName !== 'super_admin'
    "
  >
    <!--begin: Notifications -->
    <kt-notification
      [icon]="'./assets/media/svg/icons/General/Notifications1.svg'"
      [useSVG]="true"
    ></kt-notification>
    <!--end: Notifications -->
  </ng-container>
  <ng-container *ngIf="!(isFilteredView$ | async) && _user && _user.userName !== 'super_admin'">
    <div class="topbar-item" ngbTooltip="Follow-up" (click)="openAllFollowups()">
      <div class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary">
        <i class="text-primary flaticon-calendar-with-a-clock-time-tools"></i>
      </div>
    </div>
  </ng-container>
  <ng-template ngxPermissionsOnly="canViewCalender">
    <div *ngIf="!(isFilteredView$ | async)" class="topbar-item" ngbTooltip="Calendar">
      <div
        class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary"
        (click)="openCalendar()"
      >
        <span
          class="svg-icon svg-icon-xl svg-icon-primary original"
          [inlineSVG]="'./assets/media/svg/icons/General/calendar_today.svg'"
        ></span>
        <div class="symbol-label overlay">
          <a>{{ currentDate }}</a>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template ngxPermissionsOnly="communication">
    <kt-quick-action
      *ngIf="!(isFilteredView$ | async)"
      [bgImage]="'./assets/media/misc/bg-2.jpg'"
      [skin]="'dark'"
      [icon]="'./assets/media/svg/icons/Layout/Layout-4-blocks.svg'"
      [useSVG]="true"
    ></kt-quick-action>
  </ng-template>
  <ng-container *ngIf="userDisplay">
    <ng-container *ngIf="userLayout === 'dropdown'">
      <kt-user-profile [userDropdownStyle]="userDropdownStyle"></kt-user-profile>
    </ng-container>
    <ng-container *ngIf="userLayout === 'offcanvas'">
      <!--begin: User bar -->
      <kt-user-profile4></kt-user-profile4>
      <!--end: User bar -->
    </ng-container>
  </ng-container>
</ng-container>
<!-- end:: Header Topbar -->
